import forEach from 'utils/DOM/forEach'
import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'
import applyRules from './applyRules'
import store from 'utils/store/withMiddleware'
import saveToStorage from 'core/controllerPlans/saveToStorage'

function handleAddonsExternal(state, selectedPlanId) {

  forEach('.addon__input_external', node => {
    const [planId, addonId] = node.dataset.ids.split('--')
    if (planId === selectedPlanId) {
      const isSelected = addonId === state.externalPlanSelected
      node.checked = isSelected
      toggleClass(`#addon--${planId}--${addonId}`, 'active', isSelected)

      node.dataset.spValue = `${isSelected ? 'add' : 'remove'} ${addonId}`
    }
  })

  const newState = applyRules(state, { selectedPlanId })
  saveToStorage(newState)
  store.update(newState, true)

  textContent(`#value-${selectedPlanId}`, newState.plans[selectedPlanId].cost)
  textContent(`#planName-${selectedPlanId}`, newState.plans[selectedPlanId].title)
}

export default handleAddonsExternal
